import React from 'react';
import { ChevronRight } from 'lucide-react';
interface StickyNavFooterProps {
  onBack: () => void;
  onContinue: () => void;
  backLabel?: string;
  continueLabel?: string;
  continueDisabled?: boolean;
  isLoading?: boolean;
}
export function StickyNavFooter({
  onBack,
  onContinue,
  backLabel = 'Back',
  continueLabel = 'Continue',
  continueDisabled = false,
  isLoading = false
}: StickyNavFooterProps) {
  return <div className="absolute bottom-0 left-0 right-0 p-4 sm:p-6 bg-white border-t border-borderColor/50 flex items-center justify-between z-20 safe-area-inset-bottom" data-id="element-1189">
      <button onClick={onBack} className="px-4 sm:px-6 py-2.5 sm:py-3 rounded-xl font-medium text-secondary border border-borderColor hover:text-primary hover:bg-aliceBlue transition-colors text-sm sm:text-base" data-id="element-1190">
        {backLabel}
      </button>
      <button onClick={onContinue} disabled={continueDisabled || isLoading} className="bg-violetBlue text-white py-2.5 sm:py-3 px-6 sm:px-8 rounded-xl font-medium hover:bg-violetBlue/90 transition-all disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2 shadow-sm active:scale-[0.98] text-sm sm:text-base" data-id="element-1191">
        {isLoading ? <>
            <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" data-id="element-1192" />
            Processing...
          </> : <>
            {continueLabel}
            <ChevronRight className="w-4 h-4 sm:w-5 sm:h-5" data-id="element-1193" />
          </>}
      </button>
    </div>;
}